import createClient from '@pergas-pds/pds-api-client'
const baseUrl = process.env.REACT_APP_API_URL
if (typeof baseUrl !== 'string') {
  throw new Error('baseUrl must be set to a valid url')
}
export default createClient({ baseUrl })
